import Layout from 'layout';
import ScientistViewList from 'features/Scientist/pages/ViewList';
import { LayoutProvider } from '../layout/context/layoutcontext';

function ScientistViewListPage() {
  return (
    <LayoutProvider>
      <Layout>
        <ScientistViewList />
      </Layout>
    </LayoutProvider>
  );
}

export default ScientistViewListPage;
